<script>
    import { onMount } from 'svelte'
    import { fly } from 'svelte/transition'
    import { resourceConfig } from '../../store.js'
    import { handleHashChange } from '../../js/hash-scroll.js'
    import { flyModified } from '../../js/transitions.js'
    import PageSection from '../content-types/PageSection.svelte'
    import Resource from '../content-types/Resource.svelte'
    export let page

    // filter resources by current category selection
    // update on filter change
    $: resources = page.resources
        .map(resource => {
            const display = checkFilterMatch(resource, $resourceConfig.filterBy)
            return { ...resource, display }
        })

    // check if resource categories contain filter term
    function checkFilterMatch (resource, filterBy) {
        const categories = resource.categories.map(c => c.title)
        return !!filterBy.every(term => categories.includes(term))
    }

    onMount(handleHashChange) // init scroll position on mount
</script>

<div
    id="pageContent"
    in:fly={{ y: -20, duration: 1000 }}
    out:flyModified={{ y: 10, duration: 400, position: 'absolute' }}
>
    {#each page.sections as section}
        <PageSection {section} color={page.circuit_color} />
    {/each}
    <div class="section resources" style="--pageColor: {page.circuit_color};">
        <h2 class="sectionTitle" id="imagesandmovies">
            Images and Movies
        </h2>
        {#each resources as resource}
            <Resource {resource} display={resource.display} />
        {/each}
    </div>
</div>

<style lang="scss">
    @import "../../styles/vars";

    #pageContent {
        box-sizing: border-box;
        position: relative;
        width: 50vw;
        margin: 50px 25vw;
        top: 0;
    }

    .resources {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        column-gap: 1rem;

        h2 {
            grid-column: 1 / 6;
        }
    }

    @include respond-to(phone) {
        #pageContent {
            width: 96vw;
            margin: 0 2vw 50px;
        }

        .resources {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            column-gap: 1rem;

            h2 {
                grid-column: 1 / 4;
            }
        }
    }
</style>
